import { Validation, Messages } from 'utils/forms/validations';

let formHasError = false;

export const validate = (values) => {
  formHasError = false;

  let errors = {};
  let validationResult;

  validationResult = Validation.required(values.jobTitles);
  if (validationResult) {
    errors.jobTitles = validationResult;
    formHasError = true;
  }

  if (
    values.jobTitles &&
    (values.jobTitles.includes('55') || values.jobTitles.includes('66'))
  ) {
    validationResult = Validation.required(values.jobTitleOther);
    if (validationResult) {
      errors.jobTitleOther = validationResult;
      formHasError = true;
    }
  }

  if (formHasError) {
    errors._error = Messages.FILL_IN_ALL;
  }
  return errors;
};
